import React from 'react';
import { Column } from 'react-table';
import SessionTable, {
  ResponseGuard,
  SessionTableInstanceProps
} from '../index';
import { DirectCell, YesNoCell, CellFunction } from '../../cells';
import { IEpxVitals } from '../../../../../libs/apps/epxvitals';

const BPCell: CellFunction<IEpxVitals> = ({ row: { original: session } }) => {
  const { systolicBP, diastolicBP } = session;
  return (
    <span>
      {systolicBP || '?'} / {diastolicBP || '?'}
    </span>
  );
};

const EpxVitalsTable: React.FC<SessionTableInstanceProps> = (
  props
): JSX.Element => {
  const columns: Column<IEpxVitals>[] = [
    {
      Header: 'Temperature (F)',
      id: 'temperature',
      Cell: ResponseGuard(DirectCell('temperature') as CellFunction<IEpxVitals>)
    },
    {
      Header: 'BP',
      id: 'bloodPressure',
      Cell: ResponseGuard(BPCell as CellFunction<IEpxVitals>)
    },
    {
      Header: 'Heart Rate',
      id: 'heartRate',
      Cell: ResponseGuard(DirectCell('heartRate') as CellFunction<IEpxVitals>)
    },
    {
      Header: 'SpO2',
      id: 'Oxygen',
      Cell: ResponseGuard(DirectCell('oxygen') as CellFunction<IEpxVitals>)
    },
    {
      Header: 'Weight (lbs)',
      id: 'weight',
      Cell: ResponseGuard(DirectCell('weight') as CellFunction<IEpxVitals>)
    },
    {
      Header: 'Requested Outreach',
      id: 'requestCall',
      Cell: ResponseGuard(YesNoCell('requestCall') as CellFunction<IEpxVitals>)
    }
  ];
  return (
    <SessionTable<IEpxVitals>
      url="/epxvitals/data/"
      columns={columns}
      {...props}
    />
  );
};

export default EpxVitalsTable;
